import { SLAViewDto } from '@issuemanager/api-client';
import { IssueTimelineEventTypeEnum } from '@issuemanager/constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type UseSLAHelperTextParams = {
  SLAs?: SLAViewDto[];
  severity?: string;
  slaEvent?: { eventType: string } | null;
  issueSeverity?: string | null;
};

export function useSLAHelperText({
  SLAs,
  severity,
  slaEvent,
  issueSeverity,
}: UseSLAHelperTextParams): string | undefined {
  const { t } = useTranslation(['issue']);

  return useMemo(() => {
    if (!severity || !SLAs?.length) return undefined;

    const isSeverityChanging = severity !== issueSeverity;

    if (
      slaEvent?.eventType === IssueTimelineEventTypeEnum.SLADeactivated &&
      !isSeverityChanging
    ) {
      return undefined;
    }

    const selectedSLA = SLAs.find((sla) => sla.severity === severity);
    if (!selectedSLA) return undefined;
    return t('issue:form.helperText.slaApplied', {
      maxDueDate: selectedSLA.maxDueDate,
    });
  }, [SLAs, severity, slaEvent, issueSeverity, t]);
}
